/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import SmsTemplatesSmsTemplate from './SmsTemplatesSmsTemplate';

/**
 * The SmsTemplatesBody model module.
 * @module model/SmsTemplatesBody
 * @version v0.3
 */
export default class SmsTemplatesBody {
  /**
   * Constructs a new <code>SmsTemplatesBody</code>.
   * @alias module:model/SmsTemplatesBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>SmsTemplatesBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/SmsTemplatesBody} obj Optional instance to populate.
   * @return {module:model/SmsTemplatesBody} The populated <code>SmsTemplatesBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new SmsTemplatesBody();
      if (data.hasOwnProperty('sms_template'))
        obj.smsTemplate = SmsTemplatesSmsTemplate.constructFromObject(data['sms_template']);
    }
    return obj;
  }
}

/**
 * @member {module:model/SmsTemplatesSmsTemplate} smsTemplate
 */
SmsTemplatesBody.prototype.smsTemplate = undefined;

